import { IOrderService } from '../../../../app/entities/OrderService'
import { INSTALLATION_SERVICES, SERVICE_NAMES } from '../constants/service'

function isDeliveryByOrderService(orderServices: IOrderService[]): boolean {
  if (!orderServices) return false
  // Check if the order has a delivery service and no installation service
  const hasDeliveryService = orderServices.some((os) =>
    [SERVICE_NAMES.TIRE_DELIVERY, SERVICE_NAMES.TIRE_DROP_OFF].includes(
      os.label,
    ),
  )
  const hasInstallationService = orderServices.some((os) =>
    INSTALLATION_SERVICES.includes(os.label),
  )
  return hasDeliveryService && !hasInstallationService
}

export default isDeliveryByOrderService
